module.exports = __webpack_public_path__ + "img/banner.4b34f21c.jpg";